/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Header from './sub_components/main/header'
import Footer from './sub_components/main/footer'
import * as userService from '../services/userService'
import * as affiliateService from '../services/affiliateService'
import DepositModel from '../components/sub_components/user/depositeModel'
import CreditRef from './sub_components/user/creditRef'
import WithdrawModel from '../components/sub_components/user/withdrawModel'
import CreditModel from '../components/sub_components/user/creditModel'
import DebitModel from '../components/sub_components/user/debitModel'
import PasswordModel from '../components/sub_components/user/passwordModel'
import StatusModel from '../components/sub_components/user/statusModel'
import LockModel from '../components/sub_components/user/lockModel'
import RGDepositModel from '../components/sub_components/user/rgDepositModel'
import RGWithdrawModel from './sub_components/user/rgWithdrawModel'
import SettlementModel from '../components/sub_components/user/settlementModel'
import UserEventExposure from '../components/sub_components/user/userEventExposure'
import * as apiUserService from '../services/apiUserService'
import Currency from './sub_components/currency'
import { CSVLink } from 'react-csv';
import printJS from 'print-js'
import Autocomplete from 'react-autocomplete';
import { BASE_IMAGE_PATH, BASE_IMAGE_PATH_NEW } from '../configs/api';
import { showChangePasswordBtn, showCasinoControlLink, showClubGames } from '../configs/casinoShowList';
import * as _ from 'lodash'
import * as userUtil from '../util/user.util';
import ClientParentSharingModel from './sub_components/user/clientParentSharingModel';
import { OPERATOR_ID } from '../configs/const';
import AffiliateRequestTr from './affiliateRequestTr';
import moment from 'moment';
let userListInterval
let linkClickTimeout
let printClickTimeout
class AffiliateRequest extends Component {
   csvLink = React.createRef();
   constructor(props) {
      super(props);
      this.state = {
         uid: "",
         passcode: "",
         user_id: "",
         user_list: [],
         user_list_search: [],
         rg_user_list: {},
         pageLimit: 25,
         pageActive: 1,
         openPopup: "",
         selectedUser: "",
         currUserData: {},
         action: "",
         emptyClientList: false,
         shortFild: "username",
         shortType: "asc",
         searchText: "",
         showData: false,
         userDownlineList: [],
         userDownlineData: {},
         rgUserDownlineData: {},
         downline_user_id: "",
         select_downline_user_id: "",
         pdf_json: [],
         csv_json: [],
         isOfficeChannel: false,
         isOperator: false,
         allData: false,
         isOnlyClients: false,
         showClientParentSharing: false,
         selectedClientParentSharingUsr: "",
         affiliateRequestList: []

      };
   }
   onChange(e) {
      const name = e.target.name;
      const value = e.target.value;
      this.setState({ [name]: value })
   }
   componentDidMount() {
      let userData = localStorage.getItem("tokenData")
      userData = JSON.parse(userData)
      if (!!userData && !!userData.user_role && userData.user_role === "Admin") {
         this.getAffiliateRequestLst();
      } else {
         this.props.history.push('/dashboard');
      }
         
   }

   getAffiliateRequestLst() {
      const self = this;
      let tokenData = localStorage.getItem('tokenData');
      if (!!tokenData) {
         tokenData = JSON.parse(tokenData);
         // let body = {
         //    "username": tokenData.sub
         // }
         affiliateService.getAffiliateRequestList().then(async (result) => {
            if (!!result) {
               if (!!result.isSuccess) {
                  self.setState({ affiliateRequestList: result.data, showData: true });
               } else {
                  self.props.notify(result.exception.message, "error")
               }
            }
         })
      }
   }
   async componentDidMountTask() {
      const { match: { params } } = this.props;
      let tokenData = localStorage.getItem("tokenData")
      tokenData = JSON.parse(tokenData)
      let currUserData = localStorage.getItem("userAccData")
      currUserData = JSON.parse(currUserData)
      this.setState({ currUserData: currUserData, isOfficeChannel: (currUserData.username === 'office' || currUserData.parents.includes('office')), isOperator: currUserData.username === 'operator' })
      if (params.user_id) {
         let user_list = await userService.getUsersById(params.user_id)
         user_list = user_list.items
         Array.prototype.forEach.call(user_list, (user, i) => {
            if (user.role === "Client") {
               let avail = user.availableBalance
               avail = avail + user.upLineBalance + user.exposure
               user_list[i].availableBalance = avail
            }
         })

         let rg_users = {};
         // if(rg_user_list.length > 0){
         //    for (let rg_usr of rg_user_list) {
         //       rg_users[rg_usr.username] = rg_usr;
         //    }
         // }

         if (user_list.length > 0) {
            this.setState({ user_id: params.user_id, user_list: user_list, user_list_search: user_list, rg_user_list: rg_users, emptyClientList: false, showData: true }, () => {
               this.shortUser(this.state.shortFild, this.state.shortType)
            })
         } else {
            this.setState({ user_id: params.user_id, user_list: user_list, user_list_search: user_list, rg_user_list: rg_users, emptyClientList: true, showData: true }, () => {
               this.shortUser(this.state.shortFild, this.state.shortType)
            })
         }
      }
      else {
         let user_list = await userService.getUsersVsOnlyClient(this.state.isOnlyClients)
         user_list = user_list.items
         Array.prototype.forEach.call(user_list, (user, i) => {
            if (user.role === "Client") {
               let avail = user.availableBalance
               avail = avail + user.upLineBalance + user.exposure
               user_list[i].availableBalance = avail
            }
         })

         let rg_users = {};
         // if(rg_user_list.length > 0){
         //    for (let rg_usr of rg_user_list) {
         //       rg_users[rg_usr.username] = rg_usr;
         //    }
         // }

         if (user_list.length > 0) {
            this.setState({ user_list: user_list, user_list_search: user_list, rg_user_list: rg_users, emptyClientList: false, showData: true }, () => {
               this.shortUser(this.state.shortFild, this.state.shortType)
            })
         } else {
            this.setState({ user_list: user_list, user_list_search: user_list, rg_user_list: rg_users, emptyClientList: true, showData: true }, () => {
               this.shortUser(this.state.shortFild, this.state.shortType)
            })
         }
      }
      let self = this
      userListInterval = setInterval(async function userListGet() {
         clearInterval(userListInterval)
         if (params.user_id) {
            let user_list = await userService.getUsersById(params.user_id)
            user_list = user_list.items
            Array.prototype.forEach.call(user_list, (user, i) => {
               if (user.role === "Client") {
                  let avail = user.availableBalance
                  avail = avail + user.upLineBalance + user.exposure
                  user_list[i].availableBalance = avail
               }
            })

            let rg_users = {};
            // if(rg_user_list.length > 0){
            //    for (let rg_usr of rg_user_list) {
            //       rg_users[rg_usr.username] = rg_usr;
            //    }
            // }

            self.setState({ user_id: "", user_list: [] }, () => {
               if (user_list.length > 0) {
                  self.setState({ user_id: params.user_id, user_list: user_list, user_list_search: user_list, rg_user_list: rg_users, emptyClientList: false, showData: true }, () => {
                     self.shortUser(self.state.shortFild, self.state.shortType)
                  })
               } else {
                  self.setState({ user_id: params.user_id, user_list: user_list, user_list_search: user_list, rg_user_list: rg_users, emptyClientList: true, showData: true }, () => {
                     self.shortUser(self.state.shortFild, self.state.shortType)
                  })
               }
               userListInterval = setInterval(userListGet, 10000)
            })
         }
         else {
            let user_list = await userService.getUsersVsOnlyClient(self.state.isOnlyClients)
            user_list = user_list.items
            !!user_list && Array.prototype.forEach.call(user_list, (user, i) => {
               if (user.role === "Client") {
                  let avail = user.availableBalance
                  avail = avail + user.upLineBalance + user.exposure
                  user_list[i].availableBalance = avail
               }
            })

            let rg_users = {};
            // if(rg_user_list.length > 0){
            //    for (let rg_usr of rg_user_list) {
            //       rg_users[rg_usr.username] = rg_usr;
            //    }
            // }

            self.setState({ user_list: [] }, () => {
               if (user_list.length > 0) {
                  self.setState({ user_list: user_list, user_list_search: user_list, rg_user_list: rg_users, emptyClientList: false, showData: true }, () => {
                     self.shortUser(self.state.shortFild, self.state.shortType)
                  })
               } else {
                  self.setState({ user_list: user_list, user_list_search: user_list, rg_user_list: rg_users, emptyClientList: true, showData: true }, () => {
                     self.shortUser(self.state.shortFild, self.state.shortType)
                  })
               }
               userListInterval = setInterval(userListGet, 10000)
            })
         }
      }, 10000)
   }
   componentWillUnmount() {
      // clearInterval(userListInterval)
      // clearTimeout(linkClickTimeout)
      // clearTimeout(printClickTimeout)
   }
   shortUser(fild, shortType, pageChange) {
      let userList = this.state.user_list
      if (!!userList) {
         userList.sort((a, b) => (a["username"] > b["username"]) ? 1 : ((b["username"] > a["username"]) ? -1 : 0))
         if (fild !== "pendingBalance") {
            userList.sort((a, b) => (a[fild] > b[fild]) ? 1 : ((b[fild] > a[fild]) ? -1 : 0))
         } else {
            userList.sort((a, b) => (((!!a.creditRef ? a.creditRef : 0) - (!!a.balance ? a.balance : 0)) > ((!!b.creditRef ? b.creditRef : 0) - (!!b.balance ? b.balance : 0))) ? 1 : ((((!!b.creditRef ? b.creditRef : 0) - (!!b.balance ? b.balance : 0)) > ((!!a.creditRef ? a.creditRef : 0) - (!!a.balance ? a.balance : 0))) ? -1 : 0))
         }
         if (shortType === "dasc") {
            userList = userList.reverse()
         }
         userList.sort(function (a, b) { return b.isActive - a.isActive });
      }
      this.setState({ user_list: [] }, () => {
         this.setState({ pageActive: !!pageChange ? 1 : this.state.pageActive, user_list: userList, shortFild: fild, shortType: shortType })
      })
   }
   async closeAndUpdate() {
      let tokenData = localStorage.getItem("tokenData")
      tokenData = JSON.parse(tokenData)
      if (!!this.state.downline_user_id) {
         this.setState({ openPopup: '' }, () => {
            this.onSelectedUser(this.state.downline_user_id);
         });
      } else {
         let users = await userService.getUsersVsOnlyClient(this.state.isOnlyClients)
         users = users.items
         // let rg_user_list = []
         // if(!!tokenData && !!tokenData.sub){
         //    rg_user_list = await userService.getRealGamesChildUsers(tokenData.sub)
         // }

         let rg_users = {};
         // if(rg_user_list.length > 0){
         //    for (let rg_usr of rg_user_list) {
         //       rg_users[rg_usr.username] = rg_usr;
         //    }
         // }

         this.setState({ user_list: [], rg_user_list: {} }, () => {
            this.setState({ user_list: users, rg_user_list: rg_users, openPopup: "" }, () => {
               this.shortUser(this.state.shortFild, this.state.shortType)
            })
         })
      }
   }
   clean(obj) {
      for (var propName in obj) {
         if (obj[propName] === undefined) {
            delete obj[propName];
         }
      }
      return obj
   }

   async onPDFDownload(user_list_data, allData = false) {
      let pdf_json = []
      if (Object.keys(this.state.userDownlineData).length > 0) {
         pdf_json.push(this.state.userDownlineData)
      } else {
         pdf_json = user_list_data
      }
      this.setState({ pdf_json: [] }, () => {
         this.setState({ pdf_json: pdf_json, allData: allData }, () => {
            printClickTimeout = setTimeout(function () {
               printJS({
                  printable: 'printJS-div',
                  type: 'html',
                  style: '@page { size: Letter landscape;}',
                  targetStyles: ['*']
               })
            }, 500)
         })
      })
   }


   async onDownload(user_list_data, alldata = false) {
      const self = this;
      
      this.setState({ csv_json: [] }, () => {
         let items = []
         
            let i = 0

            for (let x of user_list_data) {
               if (alldata ? true : (i < (this.state.pageLimit * this.state.pageActive) && (i + 1) > (this.state.pageLimit * (this.state.pageActive - 1)))) {
                  let dictinory = {}

                  dictinory["User Name"] = x["username"]
                  dictinory["Name"] = x["name"]
                  dictinory["Mobile"] = x["mobile"]
                  dictinory["Parent Id"] = !!x["parentId"] ? x["parentId"] : ''
                  dictinory["Website"] = !!x["website"] ? x["website"] : ''
                  dictinory["Date"] = !!x["createdDate"] ? moment(x["createdDate"]).format('DD/MM/YYYY HH:mm:ss') : ''
                  items.push(dictinory)
               }
               i += 1
            }

         this.setState({ csv_json: items }, () => {
            linkClickTimeout = setTimeout(function () {
               self.csvLink.current.link.click();
            }, 500)
         })
      })
   }

   onSearch(e) {
      let userList = this.state.user_list
      this.setState({ searchText: e.target.value, user_list: [], pageActive: 1 }, () => {
         this.setState({ user_list: userList })
      })
   }

   async onUserSearch(e, name, value) {
      if (value.length > 1) {
         this.setState({ [name]: value })
         let res = await userService.getUserSearch(this.state.currUserData.username, value)
         let lst = []
         for (let x of res.usersList) {
            lst.push({ label: x, value: x, title: x, name: x })
         }
         lst.sort(function (a, b) {
            if (a.value.toLowerCase() < b.value.toLowerCase()) return -1;
            if (a.value.toLowerCase() > b.value.toLowerCase()) return 1;
            return 0;
         });
         this.setState({ userDownlineList: lst })
      }
      else if (value === "") {
         this.setState({ [name]: value, userDownlineList: [], select_downline_user_id: "", userDownlineData: {}, rgUserDownlineData: {} })
      }
      else {
         this.setState({ [name]: value, userDownlineList: [] })
      }
   }

   async onSelectedUser(user_id) {
      let userDetail = await apiUserService.getDashboard(user_id)
      // let rg_userDetail = await userService.getRealGamesUsersByUserName(user_id)

      this.setState({ userDownlineData: {}, rgUserDownlineData: {}, user_id: "" },
         () => {
            this.setState({ userDownlineData: userDetail, rgUserDownlineData: {}, select_downline_user_id: user_id, downline_user_id: user_id })
         }
      )
   }

   async changeActivation(user, isActive) {
      this.setState({ openPopup: "l", action: isActive ? "userUnlock" : "userLock", selectedUser: user })
   }
   async changeBlocking(user, isBlock) {
      this.setState({ openPopup: "l", action: isBlock ? "betLock" : "betUnlock", selectedUser: user })
   }
   onClientDownLine(usr) {
      localStorage.setItem(usr.username, JSON.stringify(usr))
      window.open("/clients/" + usr.username, "_blank")
   }
   sum(array, key) {
      return array.reduce((a, b) => a + (b[key] || 0), 0);
   }
   filterUserData() {
      let userList = this.state.user_list
      const self = this
      if (this.state.searchText !== "" || this.state.searchText !== null || this.state.searchText !== undefined) {
         userList = _.filter(userList, function (obj) {
            return (self.state.isOnlyClients ? (obj['username'].toLowerCase().indexOf(self.state.searchText.toLowerCase()) !== -1 || (userUtil.getAppropriateParent(obj.parents, self.state.currUserData.username)).toLowerCase().indexOf(self.state.searchText.toLowerCase()) !== -1) : (obj.username.toLowerCase().indexOf(self.state.searchText.toLowerCase()) !== -1));
         });
      }
      return Object.assign([], userList)
   }

   onOnlyClientButtonClick() {
      clearInterval(userListInterval);
      this.setState({ isOnlyClients: !this.state.isOnlyClients, searchText: '', downline_user_id: '', select_downline_user_id: "", userDownlineData: {}, user_list: [], user_list_search: [], showData: false, pageActive: 1 }, () => {
         clearInterval(userListInterval);
         this.componentDidMountTask();
      });
   }

   onAction(e) {
      const name = e.target.name;
      if (name === "first") {
         this.setState({ pageActive: 1 })
      } else if (name === "prev") {
         this.setState({ action: name }, this.setState({ pageActive: (this.state.pageActive - 1) }))
      } else if (name === "next") {
         this.setState({ action: name }, this.setState({ pageActive: (this.state.pageActive + 1) }))
      } else if (name === "last") {
         this.setState({ action: name }, this.setState({ pageActive: Math.ceil(this.state.user_list.length / this.state.pageLimit) }))
      }
   }


   showClientParentSharing(usr) {
      this.setState({ selectedClientParentSharingUsr: usr.username, showClientParentSharing: true });
   }

   hideClientParentSharing() {
      this.setState({ selectedClientParentSharingUsr: "", showClientParentSharing: false });
   }

   removeAffiliateRequestRow(itm){
      let affRequestLst = this.state.affiliateRequestList;
      affRequestLst.splice(affRequestLst.indexOf(itm),1);
      this.setState({affiliateRequestList : affRequestLst});
   }

   getFilteredData(){
      let rtnvl = [...this.state.affiliateRequestList];
      if(!!this.state.searchText){
         rtnvl = rtnvl.filter((itm)=> itm.username.includes(this.state.searchText) || itm.name.toLowerCase().includes(this.state.searchText.toLowerCase()) || itm.mobile.includes(this.state.searchText) || (!!itm.applicationNumber ? itm.applicationNumber.toString().includes(this.state.searchText) : false ))
      }
      return rtnvl;
   }

   render() {
      let affiliateRequestLst = this.getFilteredData()
      return (
         <div className="bethubs">
            <Header history={this.props.history} />
            <div className="wrapper">
               <div className="container-fluid container-padding-0">
                  <div className="row">
                     <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                        <div className="main-box">
                           <div>
                              <h5 className="text-blue  mb-2">
                                 <span>Affiliate Request</span>
                                 <div className="row user-header">
                                    <div className="col-12 col-sm-8 col-md-8 col-lg-8 col-xl-8">
                                    <div className="d-flex float-left">
                                          <div className="form-group mb-0 d-inline">
                                             <input className="form-control  d-inline-block" onChange={(e) => { this.onSearch(e) }} type="text" placeholder="Search" aria-label="Search" value={this.state.searchText} />
                                          </div>
                                          <CSVLink
                                             data={this.state.csv_json}
                                             filename={"Affiliate request List.csv"}
                                             asyncOnClick={true}
                                             className="d-none"
                                             ref={this.csvLink}>
                                          </CSVLink>
                                          <button className="btn btn-sm d-inline csv-icon p-0 pl-1" title="Export Data" onClick={(e) => this.onDownload(this.state.affiliateRequestList, true)} disabled={this.state.affiliateRequestList.length > 0 ? false : true}><img alt="" src={`${BASE_IMAGE_PATH_NEW}/casino/banner/images/csv-icon.svg`}></img></button>
                                          <div style={{ display: "none" }}>
                                             <div id="printJS-div">

                                                <table id="exportall" className="table font-12 table-bordered table-sm w-100" style={{ border: "1px solid #000", color: "#212529", fontSize: '12px', width: '100%' }} >
                                                   <thead>
                                                      <tr>
                                                         <th>User Name</th>
                                                         <th>Name</th>
                                                         <th>Mobile</th>
                                                         <th>Parent Id</th>
                                                         <th>Website</th>
                                                         <th>Date</th>
                                                      </tr>
                                                   </thead>
                                                   <tbody>
                                                      {this.state.pdf_json.length > 1 && this.state.pdf_json.map((usr, i) => {
                                                         return (<>
                                                            {(this.state.allData ? true : i < (this.state.pageLimit * this.state.pageActive) && (i + 1) > (this.state.pageLimit * (this.state.pageActive - 1))) && 
                                                               <tr>
                                                               <td><span>{usr.username}</span></td>
                                                               <td><span>{usr.name}</span></td>
                                                               <td><span>{usr.mobile}</span></td>
                                                               <td><span>{!!usr.parentId ? usr.parentId : ''}</span></td>
                                                               <td><span>{!!usr.website ? usr.website : ''}</span></td>
                                                               <td><span>{!!usr.createdDate ? moment(usr.createdDate).format('DD/MM/YYYY HH:mm:ss') : ''}</span></td>
                                                               </tr>
                                                      }
                                                         </>
                                                         )
                                                      })
                                                      }
                                                   </tbody>
                                                </table>
                                             </div>
                                          </div>
                                          <button className="btn btn-sm pdf-icon d-inline p-0" title="Export Data" onClick={(e) => this.onPDFDownload(this.state.affiliateRequestList, true)} disabled={this.state.affiliateRequestList.length > 0 ? false : true}>
                                             <img alt="" src={`${BASE_IMAGE_PATH_NEW}/casino/banner/images/pdf-icon.svg`}></img>
                                          </button>
                                          {/* <button className="btn btn-sm d-inline csv-icon-all p-0 mx-2" title="Export All Data" onClick={(e) => this.onDownload(userList, true)} disabled={this.state.user_list.length > 0 ? false : true}>
                                             <img alt="" src={`${BASE_IMAGE_PATH_NEW}/casino/banner/images/csv-icon-all.svg`}></img>
                                          </button>
                                          <button className="btn btn-sm pdf-icon-all d-inline p-0" title="Export All Data" onClick={(e) => this.onPDFDownload(userList, true)} disabled={this.state.user_list.length > 0 ? false : true}>
                                             <img alt="" src={`${BASE_IMAGE_PATH_NEW}/casino/banner/images/pdf-icon-all.svg`}></img>
                                          </button> */}
                                       </div>

                                    </div>
                                    <div className="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">

                                    </div>
                                 </div>
                              </h5>
                           </div>

                           <div className="row mt-1">
                              <div className="col-12 col-sm-12 col-md-12 col-lg-12 table-responsive">
                                 {!!this.state.showData ?
                                    (!!this.state.affiliateRequestList && this.state.affiliateRequestList.length > 0 ?
                                       <table id="example" className="table table-striped table-bordered table-sm addpadding nowrap" style={{ width: "100%" }}>
                                          <thead>
                                             <tr>
                                                <th>
                                                   <span>User Name</span>
                                                   <span className="d-contant" style={{ float: "right" }}>
                                                      <span onClick={() => { this.shortUser("username", "asc", true) }} style={{ fontSize: "11px", padding: "0px 0px 0px 3px", cursor: "pointer", fontWeight: "1000" }}>↑</span>
                                                      <span onClick={() => { this.shortUser("username", "dasc", true) }} style={{ fontSize: "11px", padding: "0px 0px 0px 3px", cursor: "pointer", fontWeight: "1000" }}>↓</span>
                                                   </span>
                                                </th>
                                                <th>Name
                                                   <span className="d-contant" style={{ float: "right" }}>
                                                      <span onClick={() => { this.shortUser("name", "asc", true) }} style={{ fontSize: "11px", padding: "0px 0px 0px 3px", cursor: "pointer", fontWeight: "1000" }}>↑</span>
                                                      <span onClick={() => { this.shortUser("name", "dasc", true) }} style={{ fontSize: "11px", padding: "0px 0px 0px 3px", cursor: "pointer", fontWeight: "1000" }}>↓</span>
                                                   </span>
                                                </th>
                                                <th>Mobile
                                                   <span className="d-contant" style={{ float: "right" }}>
                                                      <span onClick={() => { this.shortUser("mobile", "asc", true) }} style={{ fontSize: "11px", padding: "0px 0px 0px 3px", cursor: "pointer", fontWeight: "1000" }}>↑</span>
                                                      <span onClick={() => { this.shortUser("mobile", "dasc", true) }} style={{ fontSize: "11px", padding: "0px 0px 0px 3px", cursor: "pointer", fontWeight: "1000" }}>↓</span>
                                                   </span>
                                                </th>
                                                <th>Referrer</th>
                                                <th>Website</th>
                                                <th>Application No.</th>
                                                <th>Date
                                                   <span className="d-contant" style={{ float: "right" }}>
                                                      <span onClick={() => { this.shortUser("createdDate", "asc", true) }} style={{ fontSize: "11px", padding: "0px 0px 0px 3px", cursor: "pointer", fontWeight: "1000" }}>↑</span>
                                                      <span onClick={() => { this.shortUser("createdDate", "dasc", true) }} style={{ fontSize: "11px", padding: "0px 0px 0px 3px", cursor: "pointer", fontWeight: "1000" }}>↓</span>
                                                   </span>
                                                </th>
                                                <th>Sharing</th>
                                                <th>Affiliate Code</th>
                                                <th>Actions</th>
                                             </tr>
                                          </thead>
                                          <tbody>
                                             {affiliateRequestLst.map((usr, i) => {
                                                return (
                                                   <>
                                                      {/* {i < (this.state.pageLimit * this.state.pageActive) && (i + 1) > (this.state.pageLimit * (this.state.pageActive - 1)) && */}
                                                         <AffiliateRequestTr key={`AR_${usr.username}`} usr={usr} removeAffiliateRequestRow={(itm) => this.removeAffiliateRequestRow(itm)} notify={this.props.notify}/>
                                                      {/* } */}
                                                   </>
                                                )
                                             })}
                                          </tbody>
                                       </table> :
                                       <span> No Record Found.</span>
                                    )
                                    :
                                    <span>Loading...</span>
                                 }
                              </div>
                           </div>

                           {/* {(!!this.state.showData && Object.keys(this.state.userDownlineData).length === 0) && this.state.user_list.length > 0 &&
                              <>
                                 <div className="row">
                                    <div className="col-12 col-sm-12 col-md-6"><span className="frleft">Showing {(this.state.pageLimit * (this.state.pageActive - 1)) + 1} to {(this.state.pageLimit * this.state.pageActive) < userList.length ? (this.state.pageLimit * this.state.pageActive) : userList.length} of {userList.length} entries</span></div>
                                    <div className="col-12 col-sm-12 col-md-6">
                                       <div className="btn-group float-right" role="group" aria-label="Basic example" id="pagination-btn">
                                          <button type="button" className="btn btn-blue" id="PrevPage" name="first" onClick={(e) => this.onAction(e)} disabled={this.state.pageActive === 1 ? true : false}>First</button>
                                          <button type="button" className="btn btn-blue" id="PrevPage" name="prev" onClick={(e) => this.onAction(e)} disabled={this.state.pageActive === 1 ? true : false}>Prev</button>
                                          {/* {pages} *}
                                          {lst}
                                          {/* {this.onPagination()} *}
                                          <button type="button" className="btn btn-blue" id="NextPage" name="next" onClick={(e) => this.onAction(e)} disabled={this.state.pageActive === Math.ceil(this.state.user_list.length / this.state.pageLimit)? true : false}>Next</button>
                                          <button type="button" className="btn btn-blue" id="NextPage" name="last" onClick={(e) => this.onAction(e)} disabled={this.state.pageActive === Math.ceil(this.state.user_list.length / this.state.pageLimit)? true : false}>Last</button>
                                       </div>
                                    </div>
                                 </div>
                              </>
                           } */}
                        </div>
                     </div>
                  </div>
               </div>
            </div>
            <Footer />
         </div>
      )
   }
}
function mapStateToProps(state) {
   return {
   };
}
function mapDispatchToProps(dispatch) {
   return {
   };
}
export default connect(mapStateToProps, mapDispatchToProps)(AffiliateRequest);